import { useCallback } from "react";
import { message, Switch } from "antd";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function OpinionSwitch({ messageId, field, defaultValue, callback }) {
  const auth = useAuthContext();
  const changeHandler = useCallback(
    (value) => {
      messageService
        .partialUpdateMessage(messageId, { [field]: value }, auth.token)
        .then(() => {
          message.success("操作成功");
          callback(Date.now());
        })
        .catch((err) => {
          message.error(err.message || err);
        });
    },
    [messageId, callback, field, auth]
  );

  return <Switch defaultChecked={defaultValue} onChange={changeHandler} />;
}

export default OpinionSwitch;
